import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section className="py-24 bg-mimate-bg overflow-hidden" data-id="element-12">
      <div className="container mx-auto px-6" data-id="element-13">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-14">
          <motion.div className="w-full lg:w-1/2 relative" initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-15">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5] max-w-md mx-auto lg:mx-0" data-id="element-16">
              <img src="https://cdn.magicpatterns.com/uploads/oJY7mfDxqT6Y9ycZBhagyp/PHOTO-2026-04-17-19-10-49.jpg" alt="Valentina en Mímate Studio" className="w-full h-full object-cover" data-id="element-17" />
              <div className="absolute inset-0 border-4 border-mimate-primary/20 rounded-2xl m-4" data-id="element-18"></div>
            </div>

            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-mimate-primary/10 rounded-full -z-10 blur-2xl" data-id="element-19"></div>
          </motion.div>

          <motion.div className="w-full lg:w-1/2" initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-20">
            <h2 className="text-4xl md:text-5xl font-heading text-mimate-text mb-6" data-id="element-21">
              Sobre Valentina
            </h2>
            <div className="w-16 h-1 bg-mimate-primary mb-8 rounded-full" data-id="element-22"></div>

            <div className="space-y-6 text-lg text-mimate-text/80 leading-relaxed" data-id="element-23">
              <p data-id="element-24">
                <span className="text-2xl font-heading text-mimate-primary font-semibold" data-id="element-25">
                  "
                </span>
                Hola, soy Valentina. Mi misión es que cada mujer que entre a
                Plaza Misiones de la Noria salga sintiéndose renovada.
              </p>
              <p data-id="element-26">
                En Mímate Studio no solo transformamos tu imagen, cuidamos tu
                esencia con atención personalizada y profesionalismo. Creemos
                que la belleza es un reflejo de cómo te sientes por dentro, y
                nuestro objetivo es que te sientas poderosa, segura y hermosa.
              </p>
              <p data-id="element-27">
                Cada servicio está diseñado como un ritual de amor propio. Te
                invito a descubrir tu mejor versión con nosotros.
                <span className="text-2xl font-heading text-mimate-primary font-semibold" data-id="element-28">
                  "
                </span>
              </p>
            </div>

            <div className="mt-10" data-id="element-29">
              <img src="https://cdn.magicpatterns.com/uploads/qmsajrr5P6VNoaJuJWNXPe/Captura_de_pantalla_2026-04-17_a_la(s)_6.21.35_p.m..png" alt="Firma" className="h-16 object-contain opacity-80 mix-blend-multiply" data-id="element-30" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}